<nav 
	id="pcgMainNavigation" 
	class='navbar'
    [ngClass]="navService.isNavOpen() ? 'navbar-fixed-left' : 'navbar-collapse-left'"
>
	<!--#region Mobile header -->
	@if (
		isMobile 
		&& isLoggedOn
	) {
		<div 
			id='primaryNav' 
			class='d-flex align-items-center w-100'
		>
			<button
				aria-label="Open menu"
				[attr.aria-expanded]="this.currMainNavMenu !== ''"
				aria-controls="pcgTopClickNavEl"
				#mainHamburger
				(click)="toggleNav()"
				id="mainHamburger"
				class="btn"
			>
				<fa-icon 
					[icon]="faIconName.faBars" 
					class="hamburger-icon"
				></fa-icon>
			</button>
			<header 
				class="navbar-header" 
				[routerLink]="['/']"
			>
				HOMER
				@if (mode !== 'Production') {
                    <div class="beta-text"></div>
                }
			</header>
		</div>
	}
	<!--#endregion-->

	<!--#region Secondary nav -->
	@if (
		navService.currNav() 
		&& navService.currNav().id !== 'root'
	) {
		<div 
			id='secondaryNav' 
			class="left-shift d-flex position-relative"
		>
			<div class="name-wrapper mr-0 pr-0">
                <span class="current-section">{{ navService.dynamicNavTitle() }}</span> <!--breadcrumbs-->
			</div>
			
			<pcg-top-secondary-nav 
				role="navigation" 
                class="pl-0 w-75"
				aria-label="Secondary" 
				[forceSelect]='currForceSelect' 
				[rootNavId]='"root" + navDividerCharacter + navService.currNav()?.id?.split(navDividerCharacter)![1]' 
				[routeNavId]="$safeNavigationMigration(navService.currNav()?.id)!" 
				[navRoutes]='$safeNavigationMigration(navService.currNav()?.children)!'
				[tabPanel]="tabPanel"
				(clickedNav)="setSubNavPosition()"
			></pcg-top-secondary-nav>
        
            <div class="ml-auto d-flex justify-content-between align-items-center mr-2">
                <pcg-quick-nav-controller class="mr-2" />
                <pcg-quick-user-info />
            </div>

            @if (spinner.loadingSource()) {
                <div class="w-100 position-absolute" style="bottom: 0;">
                    <p-progressbar [dt]="loadingDt" class='w-100' mode="indeterminate" [style]="{height: '6px'}"/>
                </div>
            }
		</div>
	}	
	<!--#endregion-->	 
    
	@if (hasCiAccess) {
		<div id='bannerDiv'>
			<pcg-workstation-banner />
		</div>
	}
    @if (showInvWorkstationBanner()) {
		<div id='bannerDiv'>
			<pcg-inv-workstation class="w-100" />
		</div>
	}
    @if (isCiArea) {
		<pcg-ci-complaints />
	}

    @if (navService?.selectedMainNav() !== 'dashboard') {
        <pcg-push-notification class='w-100'></pcg-push-notification>
    }
</nav>